import { GridContainer, GridItem } from '@xing-com/grid';

import { Recommendation } from './recommendation';
import type { JobRecommendationProps } from './shared';

export const RecommendationsGrid: React.FC<JobRecommendationProps> = ({
  recommendations,
}) => (
  <GridContainer variant="FullSize">
    {recommendations.map((recommendation) => {
      return recommendation ? (
        <GridItem
          spanLarge={4}
          spanMedium={4}
          key={recommendation?.position ?? 1}
        >
          <Recommendation recommendation={recommendation} />
        </GridItem>
      ) : null;
    })}
  </GridContainer>
);
